export const isCookieEnabled = (cookieName) => (
  localStorage.getItem(cookieName) === "true"
);
